import { AiOutlineLoading3Quarters } from 'react-icons/ai';

interface Props {
  small?: boolean;
}

export function LoaderWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-1
        [&>svg]:animate-spiner"
    >
      {children}
    </div>
  );
}

export function Loading({ small }: Props) {
  return (
    <LoaderWrapper>
      <AiOutlineLoading3Quarters size={small ? 20 : 32} />

      {!small && <p>Carregando</p>}
    </LoaderWrapper>
  );
}
